import React from 'react';

import { CROP_ALIGNMENT } from '@/constants';

const CropIcon = props => {
  const { alignment, x, y, width, height } = props;

  switch (alignment) {
    case CROP_ALIGNMENT.TOP_LEFT: {
      return (
        <svg x={x} y={y} width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0V12.5H3.5V3.5L12.5 3.5V0H0Z" fill="white" />
          <path fillRule="evenodd" clipRule="evenodd" d="M3.5 3.5L12.5 3.5V0H0V12.5H3.5V3.5ZM2.5 11.5V2.5L11.5 2.5V1H1V11.5H2.5Z" fill="#007E84" />
        </svg>
      );
    }
    case CROP_ALIGNMENT.TOP_RIGHT: {
      return (
        <svg x={x} y={y} width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5 0V12.5H9V3.5L0 3.5V0H12.5Z" fill="white" />
          <path fillRule="evenodd" clipRule="evenodd" d="M9 3.5L0 3.5V0H12.5V12.5H9V3.5ZM10 11.5V2.5L1 2.5V1H11.5V11.5H10Z" fill="#007E84" />
        </svg>
      );
    }
    case CROP_ALIGNMENT.BOTTOM_LEFT: {
      return (
        <svg x={x} y={y} width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 12.5V0H3.5V9L12.5 9V12.5H0Z" fill="white" />
          <path fillRule="evenodd" clipRule="evenodd" d="M3.5 9L12.5 9V12.5H0V0H3.5V9ZM2.5 1V10L11.5 10V11.5H1V1H2.5Z" fill="#007E84" />
        </svg>
      );
    }
    case CROP_ALIGNMENT.BOTTOM_RIGHT: {
      return (
        <svg x={x} y={y} width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.5 12.5V0H9V9L0 9V12.5H12.5Z" fill="white" />
          <path fillRule="evenodd" clipRule="evenodd" d="M9 9L0 9V12.5H12.5V0H9V9ZM10 1V10L1 10V11.5H11.5V1H10Z" fill="#007E84" />
        </svg>
      );
    }
    default: {
      return null;
    }
  }
};

export default CropIcon;
